import { clsx } from "clsx";
import { useEffect, useState } from "react";
import { OtdLogo } from "@/components/layout/otd-logo";

type Slide = {
	quote: string;
	author: string;
};

/**
 * Slide background gradients are placeholders styled in `globals.css`
 * (`.social-panel__slide[data-slide]`) — TODO(OB-4): replace with
 * design-approved photography once the imagery is confirmed.
 */
const slides = [
	{
		quote:
			"Cada medição registrada no diário é uma decisão protegida. Documentar a obra é garantir que o combinado seja cumprido.",
		author: "Equipe Obra Todo Dia",
	},
	{
		quote:
			"Uma obra bem gerida começa no detalhe: o que foi feito, por quem e quando. O diário transforma rotina em transparência.",
		author: "Equipe Obra Todo Dia",
	},
	{
		quote:
			"Do canteiro ao relatório, cada dado conta. Gestão de obra é decisão tomada com a verdade em mãos.",
		author: "Equipe Obra Todo Dia",
	},
] as const satisfies readonly Slide[];

const SLIDE_INTERVAL_MS = 8000;

export function SocialPanel() {
	const [active, setActive] = useState(0);

	useEffect(() => {
		if (slides.length <= 1) return;
		const id = window.setInterval(() => {
			setActive((index) => (index + 1) % slides.length);
		}, SLIDE_INTERVAL_MS);
		return () => window.clearInterval(id);
	}, []);

	const current = slides[active] ?? slides[0];

	return (
		<aside className="social-panel">
			{slides.map((slide, index) => (
				<div
					key={slide.quote}
					aria-hidden={index !== active}
					data-slide={index}
					className={clsx(
						"social-panel__slide",
						index === active && "is-active",
					)}
				/>
			))}
			<div className="social-panel__overlay" />

			<div className="social-panel__body">
				<div className="social-panel__brand">
					<OtdLogo />
					Obra Todo Dia
				</div>

				<div className="social-panel__content">
					<figure className="social-panel__quote-figure">
						<blockquote className="social-panel__quote">
							“{current.quote}”
						</blockquote>
						<figcaption className="social-panel__author">
							{current.author}
						</figcaption>
					</figure>

					<div className="social-panel__dots" aria-hidden="true">
						{slides.map((slide, index) => (
							<span
								key={slide.quote}
								className={clsx(
									"social-panel__dot",
									index === active && "is-active",
								)}
							/>
						))}
					</div>
				</div>
			</div>
		</aside>
	);
}
